import { Component, Input, Output, EventEmitter } from '@angular/core';
import { WalletTransaction } from '../../model/myria/app/transaction';
import { TranslateService } from '@ngx-translate/core';
import { TransactionType } from "../../model/types/wallet-transactiontype-type";
import { WalletProvider } from '../../providers/wallet/wallet';
import { MOBILE_TOPUP_CATEGORY } from '../../model/models/mobile-topup/mobile-topup';
import { CommonProvider } from '../../providers/common/common';
@Component({
  selector: 'rmt-wallet-list-item',
  templateUrl: 'rmt-wallet-list-item.html'
})
export class RmtWalletListItem {
  @Input() transaction: WalletTransaction;
  @Input() statusIcon: string;
  @Input() buttonAction: any;
  @Input() showTime:boolean = false;

  @Output() selectEmitter: EventEmitter<any> = new EventEmitter();

  primaryButtonText: string;
  primaryAction: any;
  isWithdrawal: boolean = false;
  isCancelled: boolean = false;
  isDomesticTransaction: boolean = true;
  isSN: boolean = false;

  constructor(private translate: TranslateService, private walletProvider: WalletProvider, private commonProvider: CommonProvider) {
  }

  async ngAfterViewInit() {
    this.isSN = this.commonProvider.isSN();
    if(this.transaction){
      //set card ammount fee
      if(this.transaction.TransactionType == TransactionType.walletCardFee)
        this.transaction.TransactionAmount = this.transaction.TransactionFee
      if(!this.transaction.IsDomestic)
        this.isDomesticTransaction = this.transaction.IsDomestic
    }
  }

  getHeader() {
    if (this.transaction.TransactionStatus == 2) {
      return this.translate.instant('page.activityPage.eWalletWithdrawalLabel')
    } else {
      if( this.transaction.TransactionType === TransactionType.CustomerJomPayCashIn) {
        return this.translate.instant('page.activityPage.eWalletDepositThirdPartyLabel');
      } else if (this.transaction.TransactionType === TransactionType.WithdrawRequest
        || this.transaction.TransactionType === TransactionType.WithdrawConfirm
        || this.transaction.TransactionType === TransactionType.WithdrawConfirmAtMerchant) {
        return this.translate.instant('page.activityPage.eWalletWithdrawalLabel');
      } else if (this.transaction.TransactionType === TransactionType.RemittancePayment) {
        return this.translate.instant('page.eWalletPage.prepaidCardActivityPage.intlTitle');
      } else if (this.transaction.TransactionType === TransactionType.MerchantPayment && this.transaction.DestinationName === "") {
        return this.translate.instant('page.activityPage.eWalletPayInStoreLabel');
      } else if (this.transaction.TransactionType === TransactionType.SystemCredit
        || this.transaction.TransactionType === TransactionType.SystemDebit) {
        return this.translate.instant('page.activityPage.eWalletAdjustmentLabel');
      } else if (this.transaction.TransactionType === TransactionType.RemittancePaymentRefund) {
        return this.translate.instant('page.activityPage.eWalletRemittanceRefundLabel');
      } else if (this.transaction.TransactionType === TransactionType.walletCardFee || this.transaction.TransactionType === TransactionType.walletCardFeeRefund) {
        return this.translate.instant('page.eWalletPage.cardActivityPage.cardFeeLabel');
      } else if (this.walletProvider.getTransactionTypeText(this.transaction)) {
        return this.transaction.TerminalLocation;
      } else if (this.transaction.TransactionType === TransactionType.RetailPaymentRefund) {
        return this.translate.instant('page.activityPage.eWalletRefundLabel')+(this.transaction.DestinationName? ' | '+this.transaction.DestinationName:"");
      } else if (this.transaction.TransactionType === TransactionType.Transfer || this.transaction.TransactionType === TransactionType.Deposit
        || this.transaction.TransactionType === TransactionType.MerchantJomPayCashIn) {
        if(this.transaction.Multiplier === 1){
          return this.transaction.SourceName;
        } else {
          return this.transaction.DestinationName;
        }
      }  else if (this.transaction.TransactionType === TransactionType.WallettoBankAccount) {
          return  this.translate.instant('page.eWalletPage.withdrawalToBank');
      } else if(this.transaction.TransactionType === TransactionType.WalletFundedInwardRemittance){
          return  this.translate.instant('page.activityPage.eWalletMoneyReceivedLabel');
      } else if(this.transaction.TransactionType === TransactionType.Unknown){
        return  this.translate.instant('page.eWalletPage.transactionDetailsPage.unknownCategory');
      } else if(this.transaction.TransactionType === TransactionType.Disbursement){
        return  this.translate.instant('page.activityPage.eWalletDisbursementLabel');
      } else if((this.walletProvider.getWalletMobileToptupTransactionType(this.transaction) || this.walletProvider.getWalletMobileToptupRefundTransactionType(this.transaction)) && this.transaction.BillPaymentDetails){
        return  (this.transaction.BillPaymentDetails.BillerName) ? this.transaction.BillPaymentDetails.BillerName : this.transaction.DestinationName;
      } else if (this.transaction.TransactionType === TransactionType.DuitNowQRReceive) {
        return this.transaction.MerchantAccountName ? this.transaction.MerchantAccountName
          : this.translate.instant('page.eWalletPage.transactionDetailsPage.duitNowReceiveLabel');
      } else if (this.transaction.TransactionType === TransactionType.PayDuitNow || this.transaction.TransactionType === TransactionType.DuitNowFailed || this.transaction.TransactionType === TransactionType.DuitNowP2PTransfer || this.transaction.TransactionType === TransactionType.DuitNowP2PTransferFailed) {
        return this.transaction.MerchantAccountName;
      } else if(this.walletProvider.getBillPaymentTransactionType(this.transaction) || this.walletProvider.getBillPaymentRefundTransactionType(this.transaction)) {
        const billPayMerchantName = this.transaction.BillPaymentDetails && this.transaction.BillPaymentDetails.BillerName ? this.transaction.BillPaymentDetails.BillerName : this.transaction.DestinationName;
        return billPayMerchantName;
      } else if(this.transaction.TransactionType === TransactionType.CDMDeposit) {
        if(this.transaction.TerminalLocation && this.transaction.TerminalLocation !== '') {
          return this.transaction.TerminalLocation;
        }
        return this.transaction.DestinationName;
      } else {
        return this.transaction.DestinationName;
      }
    }
  }

  showInitialsAvatar() {
    return this.transaction.TransactionType === TransactionType.Transfer
      || (this.transaction.TransactionType === TransactionType.DuitNowP2PTransfer && this.transaction.MerchantAccountName !== null)
      || (this.transaction.TransactionType === TransactionType.DuitNowQRReceive && !!this.transaction.MerchantAccountName);
  }

  getThumbNailText(){
    var initial = "";
    if (this.transaction.TransactionType === TransactionType.Transfer || this.transaction.TransactionType === TransactionType.DuitNowP2PTransfer
      || this.transaction.TransactionType === TransactionType.DuitNowQRReceive) {
      var names;
      const isDuitNowQr = this.transaction.TransactionType === TransactionType.DuitNowP2PTransfer
        || this.transaction.TransactionType === TransactionType.DuitNowQRReceive;
      const splitName = isDuitNowQr ? this.transaction.MerchantAccountName : this.transaction.Multiplier === 1 ? this.transaction.SourceName : this.transaction.DestinationName;
      names = splitName ? splitName.split(" ") : '';
      if(names){
        if(names.length > 0){
          initial = names[0].substring(0,1);
        }
        if(names.length > 1){
          initial = initial + names[1].substring(0,1);
        }
      }
    }
    return initial;
  }
  isTransactionWithdrawalBool() {
    if(this.transaction.Multiplier === -1){
      this.isWithdrawal = true;
    } else {
      this.isWithdrawal = false;
    }
    return this.isWithdrawal;
  }

  isTransactionWithdrawal() {
    if (this.isTransactionWithdrawalBool()) {
      return '-';
    } else {
      return '+';
    }
  }

  isScanRequired() {
    if (!this.isSN && this.transaction.TransactionStatus === 2 && (this.transaction.TransactionType === TransactionType.WithdrawRequest || this.transaction.TransactionType === TransactionType.WithdrawRequestAtMerchant)) {
      return true
    } else {
      return false
    }
  }

  isTransactionCancelled() {
    if (this.transaction.TransactionStatus == 5) {
      return true
    } else {
      return false
    }
  }

  getSubheader() {
    if (this.isScanRequired()) {
      return this.translate.instant('page.eWalletPage.completeScanLabel')
    } else if (this.isTransactionCancelled()) {
      return this.translate.instant('page.eWalletPage.transactionsCanceledLabel')
    } else if(this.transaction.TransactionType === TransactionType.RetailPaymentRefund ||
      this.transaction.TransactionType === TransactionType.DuitNowFailed || this.transaction.TransactionType === TransactionType.walletCardFeeRefund || this.transaction.TransactionType === TransactionType.DuitNowP2PTransferFailed
    ){
      return this.translate.instant('page.activityPage.eWalletRefundLabel');
    } else if(this.transaction.TransactionType === TransactionType.MerchantPayment || this.transaction.TransactionType === TransactionType.walletCardFee || this.transaction.TransactionType === TransactionType.PayDuitNow || this.walletProvider.getBillPaymentTransactionType(this.transaction)){
      return this.translate.instant('page.eWalletPage.activityPage.paidText');
    } else if(this.transaction.TransactionType === TransactionType.RemittancePayment || this.transaction.TransactionType === TransactionType.Transfer || this.transaction.TransactionType === TransactionType.DuitNowP2PTransfer
      || this.transaction.TransactionType === TransactionType.DuitNowQRReceive){
      if(this.transaction && this.transaction.Multiplier === 1){
        return this.translate.instant('page.activityPage.eWalletMoneyReceivedLabel');
      } else {
        return this.translate.instant('page.activityPage.eWalletMoneySentLabel');
      }
    } else if(this.transaction.TransactionType === TransactionType.WallettoBankAccount || this.transaction.TransactionType === TransactionType.Withdraw){
      return this.translate.instant('page.activityPage.eWalletWithdrawalLabel');
    } else if(this.transaction.TransactionType === TransactionType.Deposit
        || this.transaction.TransactionType === TransactionType.DepositAtMerchant
        || this.transaction.TransactionType === TransactionType.CustomerJomPayCashIn
        || this.transaction.TransactionType === TransactionType.MerchantJomPayCashIn
        || this.transaction.TransactionType === TransactionType.RemittancePaymentRefund
        || this.transaction.TransactionType === TransactionType.WalletFundedInwardRemittance
        || this.transaction.TransactionType === TransactionType.CDMDeposit ){
      return this.translate.instant('page.activityPage.eWalletDepositLabel');
    } else if(this.walletProvider.getWalletMobileToptupTransactionType(this.transaction) && this.transaction.BillPaymentDetails){
      if(this.transaction.BillPaymentDetails.SubCategoryTypeId && this.transaction.BillPaymentDetails.SubCategoryTypeId.Code == (MOBILE_TOPUP_CATEGORY.BUNDLE).toString() || this.transaction.BillPaymentDetails.SubCategoryTypeId.Code == (MOBILE_TOPUP_CATEGORY.DATA_UTILISTIES).toString()){
        return this.translate.instant('page.topUpPage.bundlesLabel');
      }else{
        return this.translate.instant('page.topUpPage.airtimeLabel');
      }
    } else if(this.walletProvider.getWalletMobileToptupRefundTransactionType(this.transaction) || this.walletProvider.getBillPaymentRefundTransactionType(this.transaction)){
      return this.translate.instant('page.activityPage.eWalletRefundLabel');
    } else {
      const cardTrnsType = this.walletProvider.getTransactionTypeText(this.transaction, false);
      if(cardTrnsType) return cardTrnsType;
      else return this.translate.instant('page.eWalletPage.activityPage.transactionText');
    }
  }

  gotoButtonAction() {
    this.buttonAction(this.transaction);
  }

  generateDateStringForWalletTransaction(date: Date) {
    return `${date.getDate()} ${this.getMonth(date)}, ${this.formatAMPM(date)}`;
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  getMonth(date: Date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
      "July", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    return monthNames[date.getMonth()]
  }

  getFormattedTrnsAmount(transaction: any, isUseBillAmount: boolean = false){
    if(transaction){
      const currency = isUseBillAmount ? transaction.BillCurrency : transaction.TransactionCurrency;
      const amount = isUseBillAmount ? transaction.BillAmount : transaction.TransactionAmount;
      return this.walletProvider.getFormattedTrnsAmount(amount, currency, true)
    } else return "";
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-wallet-list-item/rmt-wallet-list-item.ts